import { useMemo } from 'react';

import { buildConciergeOverridesCss, conciergeThemeAttribute } from './concierge-theme';
import { useConciergeTheme } from './use-concierge-theme';

/**
 * Themes a Concierge entry card from the store's Concierge theme (partner,
 * Admin, then stock). Render `<ConciergeVariables $tenantOverrides={overridesCss} />`
 * once and spread `scopeProps` on the card root so only the card's own `--dcm-*`
 * tokens are re-skinned.
 */
export function useConciergeThemeScope(): {
  overridesCss: string;
  scopeProps: { className: string; 'data-concierge-theme'?: string };
} {
  const { settings } = useConciergeTheme();
  const overridesCss = useMemo(() => buildConciergeOverridesCss(settings), [settings]);

  return {
    overridesCss,
    scopeProps: { className: 'concierge-mode', 'data-concierge-theme': conciergeThemeAttribute(settings) ?? undefined },
  };
}
